import * as React from "react";

import * as LabelPrimitive from "@radix-ui/react-label";

import { cn } from "@utils/ui";

function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        // Montserrat — field labels are interactive labels (design: Typefaces).
        "flex select-none items-center gap-2 font-head text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50 group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50",
        className
      )}
      {...props}
    />
  );
}

export { Label };
